import { URL, Key } from '../view/constants/url'
import { PAGE_ID } from '../view/constants/pageId'

import { findKey, find } from 'lodash'

export const getPageId = (path: string):number => {
  const targetPageKey = findKey(URL, { path })
  let targetPageInfo = null
  if (targetPageKey) {
    targetPageInfo = find(PAGE_ID, { urlKey: targetPageKey as Key })
  }
  return targetPageInfo ? targetPageInfo.pageId : 0
}

export const hasRead = (path: string, readFirstIntroIds: number[]): boolean => {
  const currentPageId = getPageId(path)
  return !!currentPageId && readFirstIntroIds.indexOf(currentPageId) > -1
}
